var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import MobileContextMenu from './MobileContextMenu';
import InlineSvg from './InlineSvg';
import ProfileMenuLinks from './ProfileMenuLinks';
import { div } from 'semantic-ui-react';
import onClickOutside from 'react-onclickoutside';

var CompactUserMenu = function (_React$Component) {
  _inherits(CompactUserMenu, _React$Component);

  function CompactUserMenu(props) {
    _classCallCheck(this, CompactUserMenu);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onClick = function () {
      _this.setState(_extends({}, _this.state, {
        menuOpen: !_this.state.menuOpen
      }));
    };

    _this.handleClickOutside = function (evt) {
      _this.setState(_extends({}, _this.state, {
        menuOpen: false
      }));
    };

    _this.state = {
      menuOpen: false
    };
    return _this;
  }

  CompactUserMenu.prototype.render = function render() {
    var _props = this.props,
        organisations = _props.organisations,
        currentOrganisation = _props.currentOrganisation,
        teams = _props.teams,
        currentTeam = _props.currentTeam,
        organisationChange = _props.organisationChange,
        teamChange = _props.teamChange,
        authUser = _props.authUser,
        onlineStoreAccountURL = _props.onlineStoreAccountURL;
    var menuOpen = this.state.menuOpen;


    var userName = authUser && authUser.name ? authUser.name : '';

    return (
      // Need to test that using the <div> element works
      // with ReactSnap rendering
      React.createElement(
        'div',
        { className: 'compact-user-menu' },
        React.createElement(
          'button',
          { className: 'compact-user-menu__icon', onClick: this.onClick },
          React.createElement(InlineSvg, { name: 'userIcon', colour: 'grey' }),
          React.createElement(InlineSvg, {
            name: 'dropDownArrow',
            className: 'dropdown-arrow ' + (menuOpen ? 'dropdown-arrow--open' : '')
          })
        ),
        React.createElement(
          'div',
          {
            className: 'compact-user-menu__dropdown ' + (menuOpen ? 'compact-user-menu__dropdown--open' : '')
          },
          React.createElement(
            'div',
            { className: 'compact-user-menu__name' },
            userName
          ),
          organisations && organisations.length > 0 ? React.createElement(MobileContextMenu, {
            contextType: 'Organisation',
            items: organisations,
            currentItem: currentOrganisation,
            handleItemChange: organisationChange
          }) : null,
          teams && teams.length > 0 ? React.createElement(MobileContextMenu, {
            contextType: 'Team',
            items: teams,
            currentItem: currentTeam,
            handleItemChange: teamChange
          }) : null,
          React.createElement(ProfileMenuLinks, { onlineStoreAccountURL: onlineStoreAccountURL })
        )
      )
    );
  };

  return CompactUserMenu;
}(React.Component);

export default onClickOutside(CompactUserMenu);